import { Link } from "react-router-dom";

function Logo({ img }) {
    return (
        <Link className="navbar-brand p-1 p-md-3 me-0" to="/" >
            <img src={img} height="45" className="d-inline-block align-top" alt="" />
        </Link>
    );
}

export default Logo;